import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {HeaderService} from "../../../../../services/header/header.service";
import {Product} from "../../../../../models/Product";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import {ToastrService} from "ngx-toastr";
import {ProductsService} from "../../../../../services/products/products.service";


interface ExportProduct {
    'RÉFÉRENCE': string;
    'LABEL': string;
    'VALEUR EN STOCK': number;
    'PRIX D\'ACHAT': number;
    'PRIX DE VENTE': number;
    'STOCK': number;
    'ACTION'?: string; // Optional for exports
}
@Component({
  selector: 'app-etat-stock',
  templateUrl: './etat-stock.component.html',
  styleUrls: ['./etat-stock.component.scss']
})
export class EtatStockComponent implements OnInit {
    currentUser = JSON.parse(localStorage.getItem('currentUser'));
    userId = this.currentUser?.id;
    stationId = this.currentUser?.stations?.[0]?.id;
    warehouseId!: number;
    products: any[] = [];
    filteredData : any [] =[];
    allData: any[] = [];

    constructor(private productsService : ProductsService, private toastr: ToastrService, private headerService: HeaderService,private router : Router,private route: ActivatedRoute ) { }

  ngOnInit(): void {
      this.route.queryParamMap.subscribe(q => {
          this.warehouseId = Number(q.get('entrepot_id'));
          // console.log(this.warehouseId);
      });

    this.headerService.setConfig({
      title: 'Gestion de stock',
      buttons: [
          {
              label: 'Exporter',
              type: 'dropdown',
              dropdownItems: [
                  {
                      label: 'PDF',
                      action: () => this.exportTable('pdf'),
                      icon: '../../../assets/images/logo/pdf_logo.png'
                  },
                  {
                      label: 'CSV',
                      action: () => this.exportTable('csv'),
                      icon: '../../../assets/images/logo/csv_logo.png'
                  },
                  {
                      label: 'XLSX',
                      action: () => this.exportTable('xlsx'),
                      icon: '../../../assets/images/logo/xlsx_logo.png'
                  }
              ]
          }
      ]
    });
  }

    private exportTable(format: string) {
      /*  const data = this.loadProductsForWarehouse();

        if (!data) {
            return;
        }

        switch (format) {
            case 'pdf':
              //  this.exportToPDF(data);
                break;
            case 'csv':
             //   this.exportToCSV(data);
                break;
            case 'xlsx':
              //  this.exportToXLSX(data);
                break;
        }*/
    }

    private exportToPDF(data: ExportProduct[]) {

        }

    private exportToCSV(data: ExportProduct[]) {

    }

    private exportToXLSX(data: ExportProduct[]) {


    }

    retour() {
        this.router.navigate(['/stock/gestion']);
    }

}
